'use strict';

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var utils = require('./utils.js');

var drain = require('it-drain');

var filter = require('it-filter');

var take = require('it-take');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var drain__default = /*#__PURE__*/_interopDefaultLegacy(drain);

var filter__default = /*#__PURE__*/_interopDefaultLegacy(filter);

var take__default = /*#__PURE__*/_interopDefaultLegacy(take);

var BaseDatastore = /*#__PURE__*/function () {
  function BaseDatastore() {
    _classCallCheck(this, BaseDatastore);
  }

  _createClass(BaseDatastore, [{
    key: "open",
    value: function open() {
      return Promise.reject(new Error('.open is not implemented'));
    }
  }, {
    key: "close",
    value: function close() {
      return Promise.reject(new Error('.close is not implemented'));
    }
  }, {
    key: "put",
    value: function put(key, val, options) {
      return Promise.reject(new Error('.put is not implemented'));
    }
  }, {
    key: "get",
    value: function get(key, options) {
      return Promise.reject(new Error('.get is not implemented'));
    }
  }, {
    key: "has",
    value: function has(key, options) {
      return Promise.reject(new Error('.has is not implemented'));
    }
  }, {
    key: "delete",
    value: function _delete(key, options) {
      return Promise.reject(new Error('.delete is not implemented'));
    }
  }, {
    key: "putMany",
    value: function putMany(source) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step$value, key, value;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _iteratorAbruptCompletion = false;
                _didIteratorError = false;
                _context.prev = 2;
                _iterator = _asyncIterator(source);

              case 4:
                _context.next = 6;
                return _awaitAsyncGenerator(_iterator.next());

              case 6:
                if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                  _context.next = 15;
                  break;
                }

                _step$value = _step.value, key = _step$value.key, value = _step$value.value;
                _context.next = 10;
                return _awaitAsyncGenerator(_this.put(key, value, options));

              case 10:
                _context.next = 12;
                return {
                  key: key,
                  value: value
                };

              case 12:
                _iteratorAbruptCompletion = false;
                _context.next = 4;
                break;

              case 15:
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](2);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 21:
                _context.prev = 21;
                _context.prev = 22;

                if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                  _context.next = 26;
                  break;
                }

                _context.next = 26;
                return _awaitAsyncGenerator(_iterator.return());

              case 26:
                _context.prev = 26;

                if (!_didIteratorError) {
                  _context.next = 29;
                  break;
                }

                throw _iteratorError;

              case 29:
                return _context.finish(26);

              case 30:
                return _context.finish(21);

              case 31:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 17, 21, 31], [22,, 26, 30]]);
      }))();
    }
  }, {
    key: "getMany",
    value: function getMany(source) {
      var _this2 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, key;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _iteratorAbruptCompletion2 = false;
                _didIteratorError2 = false;
                _context2.prev = 2;
                _iterator2 = _asyncIterator(source);

              case 4:
                _context2.next = 6;
                return _awaitAsyncGenerator(_iterator2.next());

              case 6:
                if (!(_iteratorAbruptCompletion2 = !(_step2 = _context2.sent).done)) {
                  _context2.next = 13;
                  break;
                }

                key = _step2.value;
                _context2.next = 10;
                return _this2.get(key, options);

              case 10:
                _iteratorAbruptCompletion2 = false;
                _context2.next = 4;
                break;

              case 13:
                _context2.next = 19;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](2);
                _didIteratorError2 = true;
                _iteratorError2 = _context2.t0;

              case 19:
                _context2.prev = 19;
                _context2.prev = 20;

                if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
                  _context2.next = 24;
                  break;
                }

                _context2.next = 24;
                return _awaitAsyncGenerator(_iterator2.return());

              case 24:
                _context2.prev = 24;

                if (!_didIteratorError2) {
                  _context2.next = 27;
                  break;
                }

                throw _iteratorError2;

              case 27:
                return _context2.finish(24);

              case 28:
                return _context2.finish(19);

              case 29:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 15, 19, 29], [20,, 24, 28]]);
      }))();
    }
  }, {
    key: "deleteMany",
    value: function deleteMany(source) {
      var _this3 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _iteratorAbruptCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, key;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _iteratorAbruptCompletion3 = false;
                _didIteratorError3 = false;
                _context3.prev = 2;
                _iterator3 = _asyncIterator(source);

              case 4:
                _context3.next = 6;
                return _awaitAsyncGenerator(_iterator3.next());

              case 6:
                if (!(_iteratorAbruptCompletion3 = !(_step3 = _context3.sent).done)) {
                  _context3.next = 15;
                  break;
                }

                key = _step3.value;
                _context3.next = 10;
                return _awaitAsyncGenerator(_this3.delete(key, options));

              case 10:
                _context3.next = 12;
                return key;

              case 12:
                _iteratorAbruptCompletion3 = false;
                _context3.next = 4;
                break;

              case 15:
                _context3.next = 21;
                break;

              case 17:
                _context3.prev = 17;
                _context3.t0 = _context3["catch"](2);
                _didIteratorError3 = true;
                _iteratorError3 = _context3.t0;

              case 21:
                _context3.prev = 21;
                _context3.prev = 22;

                if (!(_iteratorAbruptCompletion3 && _iterator3.return != null)) {
                  _context3.next = 26;
                  break;
                }

                _context3.next = 26;
                return _awaitAsyncGenerator(_iterator3.return());

              case 26:
                _context3.prev = 26;

                if (!_didIteratorError3) {
                  _context3.next = 29;
                  break;
                }

                throw _iteratorError3;

              case 29:
                return _context3.finish(26);

              case 30:
                return _context3.finish(21);

              case 31:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[2, 17, 21, 31], [22,, 26, 30]]);
      }))();
    }
  }, {
    key: "batch",
    value: function batch() {
      var _this4 = this;

      var puts = [];
      var dels = [];
      return {
        put: function put(key, value) {
          puts.push({
            key: key,
            value: value
          });
        },
        delete: function _delete(key) {
          dels.push(key);
        },
        commit: function () {
          var _commit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(options) {
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.next = 2;
                    return drain__default['default'](_this4.putMany(puts, options));

                  case 2:
                    puts = [];
                    _context4.next = 5;
                    return drain__default['default'](_this4.deleteMany(dels, options));

                  case 5:
                    dels = [];

                  case 6:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          }));

          function commit(_x) {
            return _commit.apply(this, arguments);
          }

          return commit;
        }()
      };
    }
  }, {
    key: "_all",
    value: function _all(q, options) {
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                throw new Error('._all is not implemented');

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    }
  }, {
    key: "_allKeys",
    value: function _allKeys(q, options) {
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                throw new Error('._allKeys is not implemented');

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    }
  }, {
    key: "query",
    value: function query(q, options) {
      var it = this._all(q, options);

      if (q.prefix != null) {
        it = filter__default['default'](it, function (e) {
          return e.key.toString().startsWith(q.prefix);
        });
      }

      if (Array.isArray(q.filters)) {
        it = q.filters.reduce(function (it, f) {
          return filter__default['default'](it, f);
        }, it);
      }

      if (Array.isArray(q.orders)) {
        it = q.orders.reduce(function (it, f) {
          return utils.sortAll(it, f);
        }, it);
      }

      if (q.offset != null) {
        var i = 0;
        it = filter__default['default'](it, function () {
          return i++ >= q.offset;
        });
      }

      if (q.limit != null) {
        it = take__default['default'](it, q.limit);
      }

      return it;
    }
  }, {
    key: "queryKeys",
    value: function queryKeys(q, options) {
      var it = this._allKeys(q, options);

      if (q.prefix != null) {
        it = filter__default['default'](it, function (key) {
          return key.toString().startsWith(q.prefix);
        });
      }

      if (Array.isArray(q.filters)) {
        it = q.filters.reduce(function (it, f) {
          return filter__default['default'](it, f);
        }, it);
      }

      if (Array.isArray(q.orders)) {
        it = q.orders.reduce(function (it, f) {
          return utils.sortAll(it, f);
        }, it);
      }

      if (q.offset != null) {
        var i = 0;
        it = filter__default['default'](it, function () {
          return i++ >= q.offset;
        });
      }

      if (q.limit != null) {
        it = take__default['default'](it, q.limit);
      }

      return it;
    }
  }]);

  return BaseDatastore;
}();

exports.BaseDatastore = BaseDatastore;